import { AxisBottom } from "@visx/axis";
import { AnyScaleBand } from "@visx/shape/lib/types";
import { Text, getStringWidth } from "@visx/text";
import React, { useCallback } from "react";
import { colours } from "../../../../constants/colours";
import { BottomAxisProps } from "./types";

const DEFAULT_MAX_WIDTH = 100;

const BottomAxis = ({ axis, top, left, bottomScale }: BottomAxisProps) => {
  const tickComponentRenderer = useCallback(
    ({ formattedValue, ...props }) => {
      let tickLabel = formattedValue;
      let tickWidth = DEFAULT_MAX_WIDTH;

      // width of the a bar with padding
      const step = (bottomScale as AnyScaleBand)?.step?.();
      const textWidth = getStringWidth(formattedValue as string) ?? 0;

      if (step && formattedValue && textWidth > step) {
        const numChars = formattedValue.length;
        const newNumChars = Math.floor((numChars * step) / textWidth);

        tickLabel = `${formattedValue.slice(0, newNumChars - 1)}...`;
        tickWidth = step;
      }

      return (
        <Text
          {...props}
          width={tickWidth}
          fontSize={10}
        >
          {tickLabel}
        </Text>
      );
    },
    [bottomScale]
  );

  return (
    <AxisBottom
      scale={bottomScale}
      numTicks={axis?.numberOfTicks}
      left={left}
      top={top}
      tickStroke={"transparent"}
      stroke={colours.surface["100"]}
      labelProps={{
        fontSize: 10,
        textAnchor: "middle",
      }}
      tickComponent={tickComponentRenderer}
    />
  );
};

export default BottomAxis;
